<template>
  <div class="bodybox" v-if="lottery && nowLotteryList">
    <div class="title">
      <div class="l">
        <div class="l-t">
          <div class="l-t-l">
            <img
              class="img"
              v-if="lottery.iconCode"
              :src="
                _cdn + '/app/lottery_images/' +
                lottery.iconCode +
                '.png'
              "
              alt
            />
            <img
              class="img"
              v-else
              :src="
                _cdn + '/app/lottery_images/' +
                lottery.lotteryCode +
                '.png'
              "
              alt
            />
            <h3>{{ lottery.lotteryName }}</h3>
          </div>
          <div class="num" v-if="lotteryOpenPeriods">
            <span class="names">{{ lottery.lotteryName }}</span>
            第
            <span class="numbers">{{ lotteryOpenPeriods.periodsNumber }}</span>
            期开奖号码
            <lotteryNumber
              :lottery="lotteryOpenPeriods"
              types="lottery"
              :lotteryCode="lottery.lotteryCode"
            />
          </div>
        </div>
      </div>
      <div class="r" v-if="lottery[lottery.status]">
        <div class="r-l">
          <h5 class="r1" v-if="lottery.current != undefined">
            距
            <span class="numbers">{{
              lottery[lottery.status].periodsNumber
            }}</span>
            期开奖仅有
          </h5>
          <h5 class="r1" v-else>
            距第
            <span class="numbers">{{
              lottery[lottery.status].periodsNumber
            }}</span>
            期开始
          </h5>
          <template v-if="lottery.current != undefined">
            <countDown
              @endCountDown="endCountDown(lottery)"
              :endDate="lottery[lottery.status].autoCloseDate"
              types="lottery"
              :lottery="lotteryOpenPeriods"
            />
          </template>
          <template v-else>
            <countDown
              @endCountDown="endCountDown(lottery)"
              :endDate="lottery[lottery.status].autoOpenDate"
              types="lottery"
              :lottery="lotteryOpenPeriods"
            />
          </template>
          <h5
            class="r3"
            v-if="
              nowLotteryList.periodsNumberAddRule == 1 &&
              nowLotteryList.countOfDay
            "
          >
            已开{{
              Number(lotteryOpenPeriods.periodsNumber.slice(8))
            }}期，还有{{
              nowLotteryList.countOfDay -
              lotteryOpenPeriods.periodsNumber.slice(8)
            }}期
          </h5>
          <h5
            class="r3"
            v-else-if="
              nowLotteryList.periodsNumberAddRule == 2 &&
              nowLotteryList.countOfDay
            "
          >
            已开{{ nowLotteryList.uziyongyuandeshen }}期，还有{{
              nowLotteryList.countOfDay - nowLotteryList.uziyongyuandeshen
            }}期
          </h5>
          <h4 class="r3" v-else>{{ nowLotteryList.periodsIntervalDesc }}</h4>
        </div>
      </div>
    </div>
    <template v-if="queryLotteryTypeCode == '11X5'">
      <lottery11X5 />
    </template>
    <template v-if="queryLotteryTypeCode == 'K3'">
      <lotteryK3 />
    </template>
    <template v-if="queryLotteryTypeCode == '3D'||queryLotteryTypeCode == 'PL3'">
      <lottery3D />
    </template>
    <template v-if="queryLotteryTypeCode == 'LHC'">
      <lotteryLHC />
    </template>
    <template v-if="queryLotteryTypeCode == 'PCDD'">
      <lotteryPCDD />
    </template>
    <template v-if="queryLotteryTypeCode == 'PK10'">
      <lotteryPK10 />
    </template>
    <template v-if="queryLotteryTypeCode == 'SSC'">
      <lotterySSC />
    </template>
    <template v-if="queryLotteryTypeCode == 'SSQ'">
      <lotterySSQ />
    </template>
    <template v-if="queryLotteryTypeCode == 'ZHISHU'">
      <lotteryZHISHU />
    </template>
  </div>
</template>

<script>
import mix from "~/mixins/lotterydetails.mixins.vue";
import countDown from "~/components/countDown";
import lotteryNumber from "./bet/lotteryNumber";
import lottery11X5 from "./bet/lottery-11X5";
import lotteryK3 from "./bet/lottery-K3";
import lottery3D from "./bet/lottery-3D";
import lotteryLHC from "./bet/lottery-LHC";
import lotteryPCDD from "./bet/lottery-PCDD";
import lotteryPK10 from "./bet/lottery-PK10";
import lotterySSC from "./bet/lottery-SSC";
import lotterySSQ from "./bet/lottery-SSQ";
import lotteryZHISHU from "./bet/lottery-ZHISHU";
export default {
  mixins: [mix],
  computed: {
    _cdn() {
      return this.$store.getters['service/cdn']
    }
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
  components: {
    countDown,
    lotteryNumber,
    lottery11X5,
    lotteryK3,
    lotteryLHC,
    lotteryPCDD,
    lotteryPK10,
    lotterySSC,
    lottery3D,
    lotterySSQ,
    lotteryZHISHU
  },
};
</script>

<style lang="less">
.bodybox {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  overflow: hidden;
  .title {
    width: 1160px;
    height: 150px;
    padding: 20px;
    display: flex;
    background-color: #fff;
    .l {
      width: 700px;
      height: 100%;
      .l-t {
        width: 100%;
        display: flex;
        .l-t-l {
          text-align: center;
          .img {
            width: 90px;
          }
          h3 {
            display: inline-block;
            line-height: 60px;
            font-size: 18px;
            color: #000;
            font-weight: 500;
          }
        }
        .num {
          padding: 10px 0 0 18px;
          width: 100%;
          height: 100%;
          color: #666;
          .names {
            font-size: 16px;
            line-height: 19px;
            color: #000;
            margin-right: 10px;
          }
          .numbers {
            color: #f44a07;
            margin: 0 7px;
            font-size: 13px;
          }
        }
      }
    }
    .r {
      width: 460px;
      height: 100%;
      color: #666;
      .r-l {
        width: 220px;
        height: 100%;
        float: right;
        .r1 {
          height: 50px;
          line-height: 50px;
          font-weight: 500;
          .numbers {
            color: #f44a07;
            margin: 0 7px;
            font-size: 13px;
          }
        }
        .r3 {
          height: 35px;
          line-height: 35px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>